import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Store, ReportFilterDataByType, UserSystemGroupStrings } from 'store/storeTypes';
import { canEditProductionHoursSelector } from 'selectors/uiSelectors';
import { userSystemGroupSelector } from 'reducers/userSettingsReducer';
import { systemGroupSelector } from 'reducers/ui/systemGroupUiReducer';
import { filterDataSelector } from 'reducers/reports/filterDataReducer';
import {
  setWorkingHoursSite,
  setWorkingHoursSites,
  setWorkingHoursApplyMode,
  setWorkingHoursStartDate,
  toggleWorkingHoursDay,
  addWorkingHoursSlot,
  addWorkingHoursSlotAt,
  updateWorkingHoursSlot,
  removeWorkingHoursSlot,
  setWorkingHoursSystemGroup,
  setWorkingHoursSystemGroupTypes,
  setWorkingHoursViewingSystemGroupType,
  restoreWorkingHoursDay,
  openWorkingHoursEditor,
  closeWorkingHoursEditor,
  updateWorkingHoursEditorDraft,
  setWorkingHoursEditorApplyDays,
  applyWorkingHoursEditor,
} from 'actions/workingHoursActions';
import {
  getProductionHoursConfigurationRequest,
  getProductionHoursConfigurationForSitesRequest,
  saveProductionHoursConfigurationForSitesRequest,
  getProductionHoursMatrixRequest,
  getProductionHoursHolidaysRequest,
} from 'actions/productionHoursApiActions';
import { enqueueNotification } from 'actions/uiActions';
import {
  selectWorkingHoursSite,
  selectWorkingHoursSites,
  selectWorkingHoursApplyMode,
  selectWorkingHoursStartDate,
  selectWorkingHoursDays,
  selectWorkingHoursConfigurationLoadId,
  selectWorkingHoursSystemGroup,
  selectWorkingHoursSystemGroupTypes,
  selectWorkingHoursEditor,
  selectWorkingHoursEditorValidation,
  selectWorkingHoursIsMixedSystemGroupTypes,
  selectWorkingHoursViewingSystemGroupType,
  selectWorkingHoursIsMixedSites,
} from './workingHoursSelectors';
import WorkingHours from './WorkingHours';

const mapStateToProps = (state: Store) => ({
  canEdit: canEditProductionHoursSelector(state),
  userSystemGroup: userSystemGroupSelector(state) as UserSystemGroupStrings[],
  globalSystemGroup: systemGroupSelector(state) as UserSystemGroupStrings,
  selectedSystemGroup: selectWorkingHoursSystemGroup(state) as UserSystemGroupStrings,
  selectedSystemGroupTypes: selectWorkingHoursSystemGroupTypes(state),
  filterData: filterDataSelector(state) as ReportFilterDataByType,
  selectedSite: selectWorkingHoursSite(state),
  selectedSites: selectWorkingHoursSites(state),
  isMixedSites: selectWorkingHoursIsMixedSites(state),
  applyMode: selectWorkingHoursApplyMode(state),
  startDate: selectWorkingHoursStartDate(state),
  days: selectWorkingHoursDays(state),
  configurationLoadId: selectWorkingHoursConfigurationLoadId(state),
  editor: selectWorkingHoursEditor(state),
  editorValidation: selectWorkingHoursEditorValidation(state),
  isMixedSystemGroupTypes: selectWorkingHoursIsMixedSystemGroupTypes(state),
  viewingSystemGroupType: selectWorkingHoursViewingSystemGroupType(state),
  productionHoursConfiguration: state.productionHoursApi.configuration,
  isLoadingProductionHoursConfiguration: state.productionHoursApi.isLoadingConfiguration,
  isSavingProductionHoursConfiguration: state.productionHoursApi.isSavingConfiguration,
  isSaveProductionHoursConfigurationError: state.productionHoursApi.isSaveConfigurationError,
  productionHoursMatrix: state.productionHoursApi.matrix,
  isLoadingProductionHoursMatrix: state.productionHoursApi.isLoadingMatrix,
  isLoadingProductionHoursHolidays: state.productionHoursApi.isLoadingHolidays,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      setSystemGroup: setWorkingHoursSystemGroup,
      setSystemGroupTypes: setWorkingHoursSystemGroupTypes,
      setViewingSystemGroupType: setWorkingHoursViewingSystemGroupType,
      onRestoreDay: restoreWorkingHoursDay,
      onSiteChange: setWorkingHoursSite,
      setSites: setWorkingHoursSites,
      onApplyModeChange: setWorkingHoursApplyMode,
      onStartDateChange: setWorkingHoursStartDate,
      onToggleDay: toggleWorkingHoursDay,
      onAddSlot: addWorkingHoursSlot,
      onAddSlotAt: addWorkingHoursSlotAt,
      onUpdateSlot: updateWorkingHoursSlot,
      onRemoveSlot: removeWorkingHoursSlot,
      onOpenEditor: openWorkingHoursEditor,
      onCloseEditor: closeWorkingHoursEditor,
      onUpdateEditorDraft: updateWorkingHoursEditorDraft,
      onSetEditorApplyDays: setWorkingHoursEditorApplyDays,
      onApplyEditor: applyWorkingHoursEditor,
      getProductionHoursConfiguration: getProductionHoursConfigurationRequest,
      getProductionHoursConfigurationForSites: getProductionHoursConfigurationForSitesRequest,
      saveProductionHoursConfigurationForSites: saveProductionHoursConfigurationForSitesRequest,
      getProductionHoursMatrix: getProductionHoursMatrixRequest,
      getProductionHoursHolidays: getProductionHoursHolidaysRequest,
      enqueueNotification,
    },
    dispatch
  );

export type WorkingHoursProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(WorkingHours);
